<template>
  <div>
    <div>
      <div class="new-invoice-info-table">
        <h4>{{`Showing ${to || 0} from ${total || 0 }`}}</h4>
      </div>
    </div>
    <div class="all-table">
      <HeaderTable
        @newIndex="index=$event"
      />
      <div class="body-table">
        <template v-if="cActual.length > 0">
          <template v-if="loaderTable">
            <Loader />
          </template>
          <div class="headers-table">
          <div class="order">
            <h2 @click="ordernate('company_name')">Customer</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="Order by company name"
            >
          </div>
          <div class="order">
            <h2 @click="ordernate('invoice_number')">Invoice</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="Order by invoice number"
            >
          </div>
          <div class="order">
            <h2 @click="ordernate('created_at')">Date</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="Order by Date"
            >
          </div>
          <div class="order">
            <h2 @click="ordernate('updated_at')">Aging</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="Order by aging"
            >
          </div>
          <div class="order">
            <h2 @click="ordernate('amount')">Amount(USD)</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="order for customer"
            >
          </div>
          <div class="order">
            <h2 @click="ordernate('paid')">Paid(USD)</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="order for customer"
            >
          </div>
          <div class="order">
            <h2 @click="ordernate('status')">Status</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="Order by status"
            >
          </div>
          <div class="order">
            <h2 @click="ordernate('reference')">Reference</h2>
            <img
              :src="require('@/assets/icons/sort.svg')"
              alt="Order by reference"
            >
          </div>
          <div class="order">
            <h2>Actions</h2>
          </div>
        </div>
        <div class="datas-table">
          <template v-for="invoice in cActual">
            <LineTableInvoices
              :invoice="invoice"
              :key="invoice.id"
            />
          </template>
        </div>
        </template>
        <template v-else>
          <Info />
        </template>
      </div>
    </div>
  </div>
</template>
<script>
import LineTableInvoices from '@/components/Tables/LineTableInvoice.vue';
import Loader from '@/components/Loader/LoaderTable.vue';
import Info from '@/components/Infos/Info.vue';
import HeaderTable from './HeaderTable.vue';

export default {
  name: 'invoice-list',
  data() {
    return {
      index: '',
      comment: false,
      commentData: null,
      order: 'desc',
      indexTable: 0,
    };
  },
  props: {
    to: Number,
    total: Number,
    actual: [Array, String],
    loaderTable: Boolean,
    indexActual: Number,

  },
  components: {
    Loader,
    HeaderTable,
    Info,
    LineTableInvoices,
  },
  watch: {
    index() {
      this.$emit('newIndex', this.index);
    },
  },
  methods: {
    ordernate(collumn) {
      const newOrder = this.order;
      if (newOrder === 'desc') {
        this.order = 'asc';
        this.$emit('collumnSelected', { collumn, orderBy: 'desc' });
      } else {
        this.order = 'desc';
        this.$emit('collumnSelected', { collumn, orderBy: 'asc' });
      }
    },
  },
  computed: {
    cActual() {
      if (this.actual) {
        return this.actual;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.integrate {
  cursor: pointer;
  padding: 5px 10px;
  margin-top: 3px;
  border-radius: 50px;
  background-color: $backgroundDeclined;
  // color: $declined;
}
.act {
  display: flex;
}
.divider {
  display: flex;
  flex-direction: column;
}
.all-table {
  position: relative;
  width: 92.4vw;
  margin: 0 auto;
  background-color: $white;
  border-radius: 5px;
  .title-table {
    padding-left: 29px;
    height: 60px;
    border-bottom: 2px solid $backgroundData;
    display: flex;
    align-items: center;
    color: $header;
    h1 {
      font-weight: 600;
      font-size: 24px;
    }
  }
  .body-table {
    width: 92.4vw;
    position: relative;
    overflow-x: auto;
    .headers-table {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 29px;
      min-height: 65px;
      .order {
        cursor: pointer;
        position: relative;
        z-index: 2;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-right: 45px;
        @media (min-width: 1440px) {
          margin-right: 0px;
        }
        img {
          pointer-events: none;
          z-index: 0;
          width: 14px;
          height: 14px;
        }
        &:nth-child(1) {
          min-width: 127px;
        }
        &:nth-child(2) {
          min-width: 65px;
        }
        &:nth-child(3) {
          min-width: 82px;
        }
        &:nth-child(4) {
          margin-right: 25px;
          min-width: 60px;
        }
        &:nth-child(5) {
          min-width: 110px;
        }
        &:nth-child(6) {
          min-width: 95px;
        }
        &:nth-child(7) {
          min-width: 135px;
        }
        &:nth-child(8) {
          min-width: 115px;
        }
        &:nth-child(9) {
          min-width: 80px;
          display: flex;
          justify-content: center;
        }
        @media (min-width: 1440px) {
          &:nth-child(1) {
            width: 10%;
          }
          &:nth-child(2) {
            width: 10%;
          }
          &:nth-child(3) {
            width: 10%;
          }
          &:nth-child(4) {
            width: 10%;
          }
          &:nth-child(5) {
            width: 10%;
          }
          &:nth-child(6) {
            width: 10%;
          }
          &:nth-child(7) {
            width: 10%;
          }
          &:nth-child(8) {
            width: 10%;
          }
          &:nth-child(9) {
            width: 10%;
          }
        }
      }
      h2 {
        text-align: left;
        font-weight: 600;
        font-size: 14px;
        color: $header;
      }
    }
    .datas-table {
      @media (min-width: 1440px) {
        padding: 0 29px;
      }
    }
  }
}
.new-invoice-info-table {
  width: 92.4vw;
  margin: 0 auto;
  @media (max-width: 960px) {
    padding-left: 0 !important;
  }
  h4 {
    font-weight: 500;
    font-size: 14px;
    text-align: right;
    margin-bottom: 5px;
    color: #162056;
    @media (max-width: 600px) {
      width: 100%;
      padding-right: 10px;
      margin-right: -10px;
    }
  }
}
</style>
